import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=1f24bdc7&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=1f24bdc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f24bdc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/private_library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f24bdc7')) {
      api.createRecord('1f24bdc7', component.options)
    } else {
      api.reload('1f24bdc7', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=1f24bdc7&scoped=true&", function () {
      api.rerender('1f24bdc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Register.vue"
export default component.exports